import React, { useRef, useEffect } from 'react';

import { createClassName } from 'utils/createClassName';

import './dialogStyles.css';

type Props = {
  title: React.ReactNode;
  details: React.ReactNode;
  actions: React.ReactNode;
  open: boolean;
};

export const DialogComponent = (props: Props) => {
  const { title, details, actions, open } = props;

  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    if (open) {
      dialogRef.current?.showModal();
    } else {
      dialogRef.current?.close();
    }
  }, [open]);

  const createDialogClassName = createClassName('dialog');

  const wrapperClassName = createDialogClassName('wrapper');

  const titleSlotClassName = createDialogClassName('titleSlot');

  const detailsSlotClassName = createDialogClassName('detailsSlot');

  const actionsSlotClassName = createDialogClassName('actionsSlot');

  return (
    <dialog ref={dialogRef} className={wrapperClassName}>
      <div className={titleSlotClassName}>{title}</div>
      <div className={detailsSlotClassName}>{details}</div>
      <div className={actionsSlotClassName}>{actions}</div>
    </dialog>
  );
};
